import { Button, Divider, Grid, makeStyles, Typography } from "@material-ui/core";
import { useQuery } from "@redux-requests/react";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { CardItem, createImageFromInitials, Header, Loader } from "../../components";
import { types } from "../../ducks";
import { getProfile, getProfileQAs } from "../../ducks/actions";
import { ReactComponent as MeetTheExpertSvg } from "../../assets/icons/meet the expert.svg";
import QAModal from "./QAModal";

const useStyles = makeStyles(() => ({
  profileGrid: {
    padding: "2rem",
    marginBottom: "1rem"
  },
  modulesGrid: {
    marginTop: "1rem"
  },
  divImg: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "200px",
    height: "200px"
  },
  avatarImg: {
    borderRadius: "8px",
    height: "100%",
    width: "100%"
  },
  questionBtn: {
    height: "3rem"
  },
  profileNameLabel: {
    fontWeight: "bold"
  }
}));

const TeacherPage = () => {
  const [showQAModal, setShowQAModal] = useState(false);
  const classes = useStyles();
  const intl = useIntl();
  const dispatch = useDispatch();
  const { profileId } = useParams();
  const history = useHistory();

  useEffect(() => {
    dispatch(getProfile({ profileId }));
    dispatch(getProfileQAs({ profileId }));
  }, [dispatch, profileId]);

  const {
    data: { profile },
    loading: profileLoading
  } = useQuery({ type: types.GET_PROFILE, defaultData: { profile: {} } });

  const {
    data: { data: qas },
    loading: qasLoading
  } = useQuery({ type: types.GET_PROFILE_QAS, defaultData: { data: [] } });

  const onModuleClick = courseModuleId => () => {
    history.push({
      pathname: `/learn/course_modules/${courseModuleId}`
    });
  };

  const openQAModal = () => {
    setShowQAModal(true);
  };

  const handleClose = () => {
    setShowQAModal(false);
  };

  return (
    <>
      <Header
        icon={MeetTheExpertSvg}
        title={intl.formatMessage({
          id: "Pages.Teacher.AskToTeacher",
          defaultMessage: "Ask to the Teacher"
        })}
        helper={intl.formatMessage({
          id: "Pages.Teacher.Description",
          defaultMessage: "test description"
        })}
      />
      <Loader loading={profileLoading && qasLoading}>
        <Grid container className={classes.profileGrid} spacing={3}>
          <Grid
            container
            item
            alignItems="center"
            justify="flex-start"
            className={classes.avatarCell}
            xs={12}
            sm={6}
          >
            <div className={classes.divImg}>
              <img
                alt="avatar"
                src={
                  profile?.avatar ||
                  createImageFromInitials(300, `${profile.first_name} ${profile.last_name}`, "grey")
                }
                className={classes.avatarImg}
              />
            </div>
          </Grid>
          <Grid container item alignItems="center" justify="flex-end" xs={12} sm={6}>
            <Button
              className={classes.questionBtn}
              color="primary"
              variant="contained"
              onClick={openQAModal}
            >
              {intl.formatMessage({
                id: "Pages.Teacher.AskAQuestion",
                defaultMessage: "Ask a question"
              })}
            </Button>
          </Grid>
          <Grid container item alignItems="center" justify="flex-start" xs={12}>
            <Typography variant="h4" className={classes.profileNameLabel}>
              {`${profile?.first_name} ${profile?.last_name}`}
            </Typography>
          </Grid>
          <Grid container item alignItems="center" justify="flex-start" xs={12}>
            <Typography variant="body2">{`${profile?.title}`}</Typography>
          </Grid>
        </Grid>

        <Divider />

        <Grid container className={classes.modulesGrid} spacing={3}>
          <Grid container item xs={12}>
            <Typography variant="h5">
              {intl.formatMessage({
                id: "Pages.Teacher.TeacherModules",
                defaultMessage: "Teacher's modules"
              })}
            </Typography>
          </Grid>
          {profile?.course_modules?.map(courseModule => (
            <Grid item xs={12} sm={6} md={4} lg={4} key={courseModule.id}>
              <CardItem
                title={courseModule.title}
                description={courseModule.description}
                coverImageUrl={courseModule.cover_image}
                videoUrl={courseModule.recording?.video_url}
                thumbUrl={courseModule.document?.pdf?.preview_url}
                showDuration={!!courseModule.recording?.video_url}
                onClick={onModuleClick(courseModule.id)}
              />
            </Grid>
          ))}
        </Grid>
        <QAModal
          questionsAndAnswers={qas}
          profileId={profileId}
          teacherProfile={profile}
          isOpen={showQAModal}
          handleClose={handleClose}
        />
      </Loader>
    </>
  );
};

export default TeacherPage;
